















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
} from '@/core/contracts';
import { ContextsState } from '@/store';

@Component
export default class ContextSettingsPreprocessorsComponent extends Vue {
    public currentPreprocessorsSettings: string | null = null;
    public loading: boolean = false;

    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;
    private preprocessorsSettings?: string | null = null;

    public mounted() {
        this.loadSettings();
    }

    public get preprocessorsSettingsChanged(): boolean {
        return this.currentPreprocessorsSettings !== this.preprocessorsSettings;
    }

    public async changePreprocessorsSettings() {
        if (!this.preprocessorsSettingsChanged) {
            return;
        }

        const currentContextId = ContextsState.currentContextId;

        await this._fetchService!.post(
            '/contexts/' + currentContextId + '/preprocessors',
            this.currentPreprocessorsSettings
        );

        this.loadSettings();
    }

    private async loadSettings(): Promise<void> {
        this.loading = true;
        try {
            const currentContextId = ContextsState.currentContextId;

            const loadedSettings = await this._fetchService!
                .fetch('/api/v2/contexts/' + currentContextId + '/preprocessors')
                .then(response => response.text());

            this.preprocessorsSettings = loadedSettings;
            this.currentPreprocessorsSettings = this.preprocessorsSettings;
        } finally {
            this.loading = false;
        }
    }
}
